import { t } from 'i18next';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import {
  FetchCertainPaymentMethodRequest,
  FetchCertainPaymentMethodResponse,
} from '@cashier/cashier-api-model';
import {
  PaymentMethodBase,
  PaymentMethodCategory,
  PaymentTypes,
} from '@cashier/cashier-model';

import {
  fetchCertainPaymentMethodFailure,
  fetchCertainPaymentMethodStart,
  fetchCertainPaymentMethodSuccess,
  fetchPaymentMethodsFailure,
  fetchPaymentMethodsStart,
  fetchPaymentMethodsSuccess,
  inputIconsMap,
  inputMasksMap,
} from './paymentMethods.slice';

const processMethodInputs = (inputs: any[]) => {
  if (!inputs) return;

  // eslint-disable-next-line consistent-return
  return inputs.reduce((acc, curr) => {
    acc.push({
      ...curr,
      icon: inputIconsMap[curr.name],
      mask: inputMasksMap[curr.name],
    });

    return acc;
  }, []);
};

export const fetchPaymentMethodsEpic = (action$, state$, { Api }) =>
  action$.pipe(
    ofType(fetchPaymentMethodsStart.type),
    switchMap((action: { payload: PaymentTypes }) =>
      Api.fetchPaymentMethods(action.payload).pipe(
        map(
          (data: {
            payment_methods: PaymentMethodBase[];
            categories: PaymentMethodCategory[];
          }) => fetchPaymentMethodsSuccess(data),
        ),
        catchError(() => of(fetchPaymentMethodsFailure())),
      ),
    ),
  );

export const fetchPaymentMethods = (type: PaymentTypes) => ({
  type: fetchPaymentMethodsStart.type,
  payload: type,
});

export const fetchCertainPaymentMethodEpic = (action$, state$, { Api }) =>
  action$.pipe(
    ofType(fetchCertainPaymentMethodStart.type),
    switchMap((action: { payload: FetchCertainPaymentMethodRequest }) =>
      Api.fetchCertainPaymentMethod(action.payload).pipe(
        map((data: FetchCertainPaymentMethodResponse) => {
          return {
            ...data,
            method: {
              ...data.method,
              inputs: processMethodInputs(data.method.inputs),
            },
          };
        }),
        map((data: any) => fetchCertainPaymentMethodSuccess(data)),
        catchError((error) => {
          const statusCodeErrorMessages = {
            400: t('finalScreenError.badRequest'),
            404: t('finalScreenError.methodNotFound'),
            500: t('finalScreenError.internalServerError'),
          };

          const errorMessage =
            error.status in statusCodeErrorMessages
              ? statusCodeErrorMessages[error.status]
              : t('finalScreenError.internalServerError');

          return of(fetchCertainPaymentMethodFailure(errorMessage));
        }),
      ),
    ),
  );

export const fetchCertainPaymentMethod = (
  data: FetchCertainPaymentMethodRequest,
) => ({
  type: fetchCertainPaymentMethodStart.type,
  payload: data,
});
